function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f8b131;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M48.9,10.742a.75.75,0,1,0,0-1.5H44.705V6.079H48.9a.75.75,0,0,0,0-1.5H44.705v-2.6a1.979,1.979,0,1,0-3.957,0V20.027a3.11,3.11,0,1,0,3.957,0V15.405H48.9a.75.75,0,1,0,0-1.5H44.705V10.742ZM42.727,24.033a1.607,1.607,0,0,1-.837-2.981.751.751,0,0,0,.359-.64V1.979a.479.479,0,1,1,.957,0V20.412a.75.75,0,0,0,.359.64,1.607,1.607,0,0,1-.837,2.981Z",
  transform: "translate(-27.731)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M28.2,92.463a3.479,3.479,0,0,1-2.5-1.047,2.023,2.023,0,0,0-3.031,0,3.5,3.5,0,0,1-4.99,0,2.021,2.021,0,0,0-3.029,0,3.5,3.5,0,0,1-4.99,0,2.045,2.045,0,0,0-1.515-.683.75.75,0,0,1,0-1.5,3.478,3.478,0,0,1,2.495,1.047,2.021,2.021,0,0,0,3.029,0,3.5,3.5,0,0,1,4.99,0,2.022,2.022,0,0,0,3.03,0,3.5,3.5,0,0,1,4.991,0,2.023,2.023,0,0,0,3.031,0,3.478,3.478,0,0,1,2.5-1.047.75.75,0,1,1,0,1.5,2.046,2.046,0,0,0-1.516.683A3.477,3.477,0,0,1,28.2,92.463Z",
  transform: "translate(-5.179 -62.463)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M4.761,75.455a3.478,3.478,0,0,1-2.495-1.047,2.045,2.045,0,0,0-1.515-.683.75.75,0,0,1,0-1.5,3.479,3.479,0,0,1,2.5,1.047,2.021,2.021,0,0,0,3.029,0A3.476,3.476,0,0,1,8.77,72.225a.75.75,0,1,1,0,1.5,2.043,2.043,0,0,0-1.514.683A3.478,3.478,0,0,1,4.761,75.455Z",
  transform: "translate(0 -50.557)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M73.026,75.455a3.477,3.477,0,0,1-2.495-1.047,2.046,2.046,0,0,0-1.515-.683.75.75,0,0,1,0-1.5,3.479,3.479,0,0,1,2.5,1.047,2.022,2.022,0,0,0,3.03,0,3.478,3.478,0,0,1,2.5-1.047.75.75,0,1,1,0,1.5,2.046,2.046,0,0,0-1.515.683A3.477,3.477,0,0,1,73.026,75.455Z",
  transform: "translate(-47.785 -50.557)"
}));

var SvgCoolantTemp = function SvgCoolantTemp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoolantTemp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coolant-temp.d784dea2.svg";
export { ForwardRef as ReactComponent };